export const INVOICING_CONFIG_VALIDATION_RULES = {
	creditsInvoiceFrequency: {
		regex: {
			value: {
				pattern: /^\d*$/,
				customMessageKey: "validation.customMessages.numeric",
			},
		}
	},

	creditsInvoiceCount: {
		regex: {
			value: {
				pattern: /^\d*$/,
				customMessageKey: "validation.customMessages.numeric",
			},
		}
	}
};


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoicing-configuration/invoicingConfigurationValidationRules.js